import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core'
import {CarouselComponent} from 'ngx-owl-carousel-o'
import {DateFormatService, OptionsNgxOwCarouselService} from 'dmmp-services'

@Component({
  selector: 'dmmp-website-carousel-articles-featured',
  templateUrl: './website-carousel-articles-featured.component.html'
})
export class WebsiteCarouselArticlesFeaturedComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() module
  @Output() page = new EventEmitter()
  @ViewChild('owl') carrousel: CarouselComponent
  currentPage = 1
  configBenefits
  cantSlides

  constructor(private options: OptionsNgxOwCarouselService, public dateFormat: DateFormatService) {
  }

  ngOnInit() {
    this.cantSlides = this.data.length < 4 ? this.data.length : 4
    this.configBenefits = this.options.configurationBenefits(this.module)
  }

  newPageEvent(newPage) {
    if (newPage.direction === 'next') {
      this.carrousel.next()
      this.currentPage = newPage.number
    } else {
      this.carrousel.prev()
      this.currentPage = newPage.number
    }
  }

  changeOwl(event) {
    if (event.startPosition + 1 !== this.currentPage) {
      this.currentPage = event.startPosition + 1
    }
  }
}
